import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserInfo} from '@app/model/user-info.model';
import {BehaviorSubject} from 'rxjs';
import {LanguageService} from '@app/services/language.service';

@Component({
	selector: 'app-sidenav-mobile',
	templateUrl: './sidenav-mobile.component.html',
	styleUrls: ['./sidenav-mobile.component.scss']
})
export class SidenavMobileComponent {
	@Input() userInfo?: UserInfo | null;
	@Output() toggleSidenav = new EventEmitter();

	showLanguages = new BehaviorSubject<boolean>(false);

	constructor(public languageService: LanguageService) {
	}
}
